"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivMarginMobile = exports.FormBody = exports.ButtomSuiteForm = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const antd_1 = require("antd");
exports.ButtomSuiteForm = (0, styled_components_1.default)(antd_1.Button) `
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  background-color: #c31c4a;
  justify-content: space-between;
  color: #fff;
`;
exports.FormBody = styled_components_1.default.div `
  transition: max-height 1s, opacity 1s ease-out;
  display: block;
  max-height: 0;
  width: 100%;
  opacity: 0;
  overflow: hidden;
  ${props => props.showForm &&
    (0, styled_components_1.css) `
      max-height: 3000px;
      opacity: 1;
    `}
  ${props => props.enable &&
    (0, styled_components_1.css) `
      pointer-events: none;
      opacity: 0.4;
    `}
`;
exports.DivMarginMobile = styled_components_1.default.div `
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    > img {
      margin: 0 10px;
    }
  }
  @media screen and (max-width: 992px) {
    display: flex;
    margin-top: 15px;
    > span {
      text-align: center;
    }
    > div {
      justify-content: center;
      > img {
        margin: 0 5px;
      }
    }
  }
`;
